"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StueckpreisVariant = void 0;
var StueckpreisVariant;
(function (StueckpreisVariant) {
    StueckpreisVariant["au585ag925"] = "au585ag925";
    StueckpreisVariant["edelstahl"] = "edelstahl";
    StueckpreisVariant["titan"] = "titan";
    StueckpreisVariant["tungsten"] = "tungsten";
    StueckpreisVariant["allgemein"] = "allgemein";
    StueckpreisVariant["ohneStein"] = "ohneStein";
    StueckpreisVariant["brillant"] = "brillant";
    StueckpreisVariant["zirkonia"] = "zirkonia";
})(StueckpreisVariant = exports.StueckpreisVariant || (exports.StueckpreisVariant = {}));
//# sourceMappingURL=StueckpreisVariant.js.map